import { Injectable } from '@angular/core';
import {
    BootStockLocalMaterialModel,
    BootStockLocalMaterialModelJson,
} from '../../models/low-level/boot-stock-local-material.model';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageCseStockService {
    private readonly KEY_BOOT_STOCK_MATERIALS = 'bootStockMaterials';
    public constructor(private readonly localStorageCommonService: LocalStorageCommonService) {}

    public saveBootStockLocalMaterialModels(materials: BootStockLocalMaterialModel[]): void {
        this.localStorageCommonService.storageSet(this.KEY_BOOT_STOCK_MATERIALS, materials);
    }

    public getBootStockLocalMaterialModels(): BootStockLocalMaterialModel[] {
        const localBootStock =
            this.localStorageCommonService.storageGet<BootStockLocalMaterialModelJson[]>(
                this.KEY_BOOT_STOCK_MATERIALS,
            ) || [];
        return localBootStock.map((bootstock) => {
            return new BootStockLocalMaterialModel(
                bootstock.materialNumber,
                bootstock.storageLocation,
                bootstock.quantity,
            );
        });
    }

    public deleteBootStockMaterials(): void {
        this.localStorageCommonService.storageRemove(this.KEY_BOOT_STOCK_MATERIALS);
    }
}
